import { types } from "mobx-state-tree"
import PaginationOptions from './PaginationOptions'

const AccountTransactionsUIStore = types.compose(
    PaginationOptions,
    types.model({

    })
)

export default AccountTransactionsUIStore.create({
    rowsPerPage: 10,
    page: 0
})


// WEBPACK FOOTER //
// ./src/stores/AccountTransactionsUIStore.js